import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface AcessoBloqueadoModalData {
  mensagem: string;
}

@Component({
  selector: 'app-acesso-bloqueado-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './acesso-bloqueado-modal.component.html',
  styleUrl: './acesso-bloqueado-modal.component.css',
})
export class AcessoBloqueadoModalComponent implements OnInit, OnDestroy {
  mensagem: string;
  contador: number = 10;

  private interval: ReturnType<typeof setInterval>;

  constructor(
    public dialogRef: MatDialogRef<AcessoBloqueadoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AcessoBloqueadoModalData
  ) {
    this.mensagem = data.mensagem;
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.contador--;
      if (this.contador <= 0)
        this.sair();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  sair(): void {
    clearInterval(this.interval);
    this.dialogRef.close();
  }
}
